/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type WorkflowNavigationSettingsType from '@jira/spa-apps__project-settings-workflow-navigation/src/WorkflowNavigationPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyWorkflowNavigationSettings: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof WorkflowNavigationSettingsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-workflow-navigation", jiraSpaEntry: "async-project-settings-workflow-navigation" */ '@jira/spa-apps__project-settings-workflow-navigation/src/WorkflowNavigationPage.tsx'
		),
	),
);

const AsyncWorkflowNavigationSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyWorkflowNavigationSettings}
		pageId="project-settings-workflow-navigation"
		shouldShowSpinner={false}
	/>
);

export default AsyncWorkflowNavigationSettings;
